import { isEmpty, map } from 'lodash/fp';
import portableTextToPlain from '@ahmdigital/logic/lib/content/utils/portable-text-to-plain';

import { CONTENT_SECTIONS } from '../../../content/sections';
import { Maybe, ValueProposition } from '../../../../../types/__codegen__/sanity/graphql';
import { PortableTextType } from '../../../../../types/sanityInternal';
import getImageAttributes from '../../../../../cms/utils/get-image-attributes';

type Props = {
  cmsSectionContent: {
    benefits?: ValueProposition[];
    sloganRaw?: PortableTextType[];
  };
  insuranceType?: Maybe<string> | undefined;
};

const mapCoreBenefitsContent = ({ cmsSectionContent, insuranceType }: Props) => {
  if (isEmpty(cmsSectionContent)) {
    return null;
  }

  const formattedBenefits = map(
    (coreBenefit) => ({
      cta: {
        title: coreBenefit?.urlObject?.name ? coreBenefit?.urlObject?.name : null,
        to: coreBenefit?.urlObject?.url ? coreBenefit?.urlObject?.url : null,
      },
      description: portableTextToPlain(coreBenefit.summaryRaw),
      image: getImageAttributes({ imageObject: coreBenefit.imageObject }),
      title: coreBenefit.name,
    }),
    cmsSectionContent.benefits,
  );

  return {
    content: {
      benefits: formattedBenefits,
      slogan: portableTextToPlain(cmsSectionContent.sloganRaw),
    },
    insuranceType,
    type: CONTENT_SECTIONS.CORE_BENEFITS,
  };
};

export default mapCoreBenefitsContent;
